import { render, staticRenderFns } from "./customer-dialog-app.vue?vue&type=template&id=15458a64"
import script from "./customer-dialog-app.vue?vue&type=script&lang=js"
export * from "./customer-dialog-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports